import {Grid} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {Select} from '@yandex-delivery/nlf-form/v2'
import {memo} from 'react'
import {useController, useFormContext} from 'react-hook-form'

import type {DropdownListWidgetProps as Props} from '../types'

const grid = css`
  margin-block-end: ${spacing(1)};
`

export const DropdownListWidget = memo<Props>(props => {
  const {form_state_key, options, placeholder, dataTestId} = props.config
  const defaultOption = options.find(option => option.is_default)
  const {control} = useFormContext()
  const {
    field: {value, onChange},
  } = useController({
    control,
    name: form_state_key,
    defaultValue: defaultOption?.value,
  })

  const optionsForSelect = options.map(option => ({
    label: option.label.items[0]?.text,
    value: option.value,
  }))
  // может прийти валидное falsy значение
  // берем нулевой элемент, потому что items - издержка схемы конфигов,
  // тут нельзя передать просто текстовый виджет, только массив с одним элементом
  const placeholderText = placeholder?.items[0]?.text

  return (
    <Grid className={grid} item xs>
      <Select<string>
        data-testid={dataTestId}
        defaultValue={defaultOption?.value}
        name={form_state_key}
        onChange={e => {
          onChange(e?.value)
        }}
        options={optionsForSelect}
        placeholder={placeholderText}
        value={value}
      />
    </Grid>
  )
})
